import { IAlterarDadosEmMassaRepasse } from "../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import {
    IExportExcelRepasseFiltro,
    IGestaoRepasseFiltro,
} from "../../../Interfaces/Repasse/GestaoRepasse/GestaoRepasseInterfaces";
import {
    ExportarExcelAtendimentosRepasseService,
    ExportarExcelRepasseService,
    ListarGestaoRepasseService,
    AlterarDadosEmMassaRepasseService,
    AlterarDadosExcelRepasseService,
    LeituraUpdateExcelService,
} from "../../../Services/Repasse/GestaoRepasse/GestaoRepasseServices";
import { Controller } from "../../Controller";

export async function ListarGestaoRepasseController(
    requestBody: IGestaoRepasseFiltro
) {
    return Controller(ListarGestaoRepasseService(requestBody));
}

export async function ExportarExcelRepasseController(
    requestBody: IExportExcelRepasseFiltro
) {
    return Controller(ExportarExcelRepasseService(requestBody));
}

export async function ExportarExcelAtendimentosRepasseController(
    SEG_ATENDIMENTOS: string,
    requestBody: IGestaoRepasseFiltro
) {
    return Controller(
        ExportarExcelAtendimentosRepasseService(SEG_ATENDIMENTOS, requestBody)
    );
}

export async function AlterarDadosEmMassaRepasseController(
    requestBody: IAlterarDadosEmMassaRepasse
) {
    return Controller(AlterarDadosEmMassaRepasseService(requestBody));
}

export async function AlterarDadosExcelRepasseController(
    requestBody: FormData
) {
    return Controller(AlterarDadosExcelRepasseService(requestBody));
}

export async function LeituraUpdateExcelController(requestBody: Array<number>) {
    return Controller(LeituraUpdateExcelService(requestBody));
}
